import { OtcMedicineContainer } from '@containers/medicine';
import SeoPageShell from '@com/seo/SeoPageShell';
import { seoBreadcrumbs } from '@constant/seo/breadcrumbs';
import { pageMetadata } from '@constant/seo/pageMetadata';
import { createSsrPageProps } from '@utilities/ssr/createSsrPageProps';
import { otcMedicinePrefetchQueries } from '@utilities/ssr/prefetchConfigs';

const OtcMedicinePage = () => {
  return (
    <SeoPageShell
      {...pageMetadata.otcMedicine}
      breadcrumbs={[...seoBreadcrumbs.otcMedicine]}
    >
      <OtcMedicineContainer />
    </SeoPageShell>
  );
};

export default OtcMedicinePage;

export const getServerSideProps = createSsrPageProps({
  prefetchQueries: otcMedicinePrefetchQueries,
});
